import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import RoutesConfig from "./All Routing/Routesconfig";
const App = () => {
  
  return(
    <div className="App">
      <RoutesConfig/>
    </div>
  )
}
export default App;
